import React from 'react';

import { PageUiNavBar } from '../../components/Layout/PageNavBar/PageUiNavBar';

export function UsersMenu({
  limitedAccess,
}: {
  limitedAccess?: boolean;
}): JSX.Element {
  return (
    <PageUiNavBar
      bars={
        limitedAccess
          ? [
              {
                text: 'Users',
                page: '/users',
              },
            ]
          : [
              {
                text: 'Users',
                page: '/users',
              },
              {
                text: 'Accounts',
                page: '/users/accounts',
              },
              {
                text: 'Store settings',
                page: '/users/storesettings',
              },
              {
                text: 'Brands',
                page: '/users/brands',
              },
              {
                text: 'Invite users',
                page: '/users/invite',
              },
            ]
      }
    />
  );
}
